/** Shared typography — DM Sans (app) + system mono (code). */

export const GOOGLE_FONTS_URL =
  "https://fonts.googleapis.com/css2?family=DM+Sans:wght@300;400;500;600;700&family=Orbitron:wght@400;600;700;800;900&family=Oxanium:wght@300;400;500;600;700&display=swap";

export const FONT_FAMILY = "'DM Sans', system-ui, -apple-system, sans-serif";
export const FONT_FAMILY_DISPLAY = FONT_FAMILY;
export const FONT_FAMILY_MONO = "ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, monospace";

export const DEFAULT_TYPOGRAPHY = {
  googleFontsUrl: GOOGLE_FONTS_URL,
  fontFamily: FONT_FAMILY,
  fontFamilyDisplay: FONT_FAMILY_DISPLAY,
  fontFamilyMono: FONT_FAMILY_MONO,
};
